import React, { useState } from "react";
import Breadcrumb from "../../../../components/Breadcrum";
import { ArrowRight } from "lucide-react";
import "./Automobiles.css";

export default function Automobiles() {
  const automobiles = [
    {
      id: 1,
      name: "KIA KX1",
      image: "/assets/img/Automobiles/Kia-KX1.jpg",
      details: [
        {
          title: "Exterior Features",
          points: [
            "Projector Headlights",
            "Boomerang-Style LED Daytime Running Lights",
            "Mirror-Finish Alloy Wheels",
            "Roof Rails",
            "Exterior Mirrors with Integrated Turn Signals",
            "Satin Chrome Door Handles",
            "Shark Fin Antenna",
            "Electric Sunroof",
            "Dual-Tone Body Design",
          ],
        },

        {
          title: "Technical Specifications",
          points: [
            "1.4L Petrol Engine",
            "1368cc Displacement",
            "100 PS Power",
            "132.4 Nm Torque",
            "IVT Automatic Transmission",
            "176 km/h Top Speed",
            "6.13L / 100km Fuel Consumption",
            "43L Fuel Tank Capacity",
          ],
        },

        {
          title: "Safety Features",
          points: [
            "ABS + EBD Braking System",
            "ESC Electronic Stability Control",
            "Hill Start Assist",
            "Rear View Camera",
            "Front & Rear Parking Sensors",
            "TPMS Tire Monitoring System",
            "Side Airbags",
            "Child Safety Locks",
          ],
        },

        {
          title: "Interior & Comfort",
          points: [
            "Leather Seats",
            "Automatic Climate Control",
            "Electric Sunroof",
            "Smart Key Push Button Start",
            "6:4 Split Folding Rear Seats",
            "Leather Steering Wheel",
          ],
        },

        {
          title: "Technology & Entertainment",
          points: [
            "8-inch Multimedia Display",
            "Apple CarPlay Support",
            "USB Connectivity",
            "6 Premium Speakers",
            "Cruise Control",
            "Smart Infotainment System",
          ],
        },

        {
          title: "Exterior Colors",
          points: [
            "Sky Blue",
            "Transparent White",
            "Sunrise Red",
            "Rhythm Yellow",
            "Ceramic White",
          ],
        },
      ],
    },

    {
      id: 2,
      name: "KIA SELTOS",
      image: "/assets/img/Automobiles/KIA-SELTOS.jpg",

      details: [
        {
          title: "Exterior Features",
          points: [
            "Star-map LED Combination Headlamps",
            "Full-width LED Combination Tail Lamps",
            "17-inch Aluminum Alloy Mirror-finish Wheels",
            "Bold Futuristic SUV Design",
            "Dual-Tone Premium Exterior Styling",
            "Shark Fin Antenna",
            "Electric Sunroof",
            "Chrome Door Handles",
          ],
        },

        {
          title: "Interior & Comfort",
          points: [
            "Dual 10.25-inch Integrated Display Screens",
            "Wireless Phone Charging",
            "Front Seat Heating & Ventilation",
            "6-Way Power Adjustable Driver Seat",
            "Rear Seat Adjustable Backrest",
            "Premium Leather Interior",
            "Spacious Cabin Design",
            "LCD Visible Shift Lever",
          ],
        },

        {
          title: "Smart Technology",
          points: [
            "Kia Connect Intelligent Connectivity",
            "Smart Cruise Control",
            "Highway Driving Assist",
            "Wireless Smartphone Connectivity",
            "Advanced Infotainment System",
            "Digital Driver Display",
            "AI-Based Driving Assistance",
          ],
        },

        {
          title: "Advanced Safety Features",
          points: [
            "FCA - Forward Collision Avoidance Assist",
            "LKA - Lane Keeping Assist",
            "ISLA - Intelligent Speed Limit Assist",
            "DAW - Driver Attention Warning",
            "HBA - High Beam Assist",
            "NSCC - Navigation Based Smart Cruise Control",
            "Multiple Airbags",
            "Electronic Stability Control",
          ],
        },

        {
          title: "Performance & Engine",
          points: [
            "1.4T + 7DCT Turbo Engine",
            "140 PS Maximum Power",
            "242 Nm Maximum Torque",
            "6.26L / 100km Fuel Consumption",
            "1.5L + IVT Engine Option",
            "115 PS Maximum Power",
            "143.8 Nm Maximum Torque",
            "Smooth Automatic Driving Experience",
          ],
        },

        {
          title: "Driving Experience",
          points: [
            "Smooth IVT Automatic Transmission",
            "Comfortable & Silent Cabin",
            "Excellent Fuel Efficiency",
            "Responsive Steering Control",
            "Stable Highway Performance",
            "Advanced Suspension System",
            "Easy Urban Driving Experience",
            "Powerful Yet Comfortable Ride Quality",
          ],
        },
      ],
    },

    {
      id: 3,
      name: "KIA K3",
      image: "/assets/img/Automobiles/KIA-K3.jpg",
      details: [
        {
          title: "Exterior Features",
          points: [
            "Star Map LED Headlights",
            "LED Daytime Running Lights",
            "LED Combination Tail Lamps",
            "17-inch Aluminum Alloy Wheels",
            "Electric Sunroof",
            "Shark Fin Antenna",
            "Chrome Door Handles",
            "Sporty Dual Exhaust Design",
          ],
        },

        {
          title: "Interior & Comfort",
          points: [
            "10.25-inch Smart Display",
            "10-Way Power Adjustable Driver Seat",
            "Premium Leather Seats",
            "Automatic Air Conditioning",
            "Ambient Lighting (71 Colors)",
            "Rear AC Vent",
            "One-Button Start + Smart Key",
            "Wireless Phone Charging",
          ],
        },

        {
          title: "Smart Technology",
          points: [
            "Kia Connect Intelligent Connectivity",
            "OTA Software Updates",
            "Real-Time Online Navigation",
            "BLE Bluetooth Digital Key",
            "Voice Interaction System",
            "Remote Vehicle Control",
            "Online Entertainment Services",
            "10.25-inch Digital Instrument Cluster",
          ],
        },

        {
          title: "Advanced Safety Features",
          points: [
            "FCA Forward Collision Avoidance Assist",
            "LKA Lane Keeping Assist",
            "LFA Lane Following Assist",
            "HDA Highway Driving Assist",
            "Smart Cruise Control",
            "Blind Spot Collision Avoidance Assist",
            "Rear Cross Traffic Collision Warning",
            "Electronic Stability Control",
          ],
        },

        {
          title: "Performance & Engine",
          points: [
            "1.5L + IVT Engine",
            "115 PS Maximum Power",
            "143.9 Nm Maximum Torque",
            "5.55L WLTC Fuel Consumption",
            "1.4T + 7DCT Turbo Engine",
            "140 PS Maximum Power",
            "211 Nm Maximum Torque",
            "Top Speed up to 200 km/h",
          ],
        },

        {
          title: "Driving Experience",
          points: [
            "Smooth IVT Automatic Transmission",
            "Sporty & Responsive Driving",
            "Comfortable Premium Cabin",
            "Excellent Highway Stability",
            "Fuel Efficient Performance",
            "Advanced Suspension System",
            "Quiet & Refined Ride Quality",
            "Driver-Focused Cockpit Design",
          ],
        },
      ],
    },
  ];

  const [selectedAuto, setSelectedAuto] = useState(null);

  const closeModal = () => {
    setSelectedAuto(null);
  };

  return (
    <>
      <Breadcrumb
        title="Automobile Solutions"
        backgroundImage="/assets/img/contact-banner.png"
        height="40vh"
      />

      <section className="auto-section">
        <div className="container">
          <h1 className="auto-title">Automobile Solutions</h1>

          <p className="auto-subtitle">
            Explore our advanced automotive solutions designed for modern
            mobility and future transportation industries.
          </p>

          <div className="auto-grid">
            {automobiles.map((item) => (
              <div className="auto-card" key={item.id}>
                <div className="auto-img-box">
                  <img src={item.image} alt={item.name} />
                </div>

                <div className="auto-info">
                  <h2 className="auto-name">{item.name}</h2>

                  <button
                    className="view-btn"
                    onClick={() => setSelectedAuto(item)}
                  >
                    View Details <ArrowRight size={16} />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {selectedAuto && (
            <div className="modal-overlay" onClick={closeModal}>
              <div
                className="modal-content"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={selectedAuto.image}
                  alt={selectedAuto.name}
                  className="modal-image"
                />

                <h2 className="modal-title">{selectedAuto.name}</h2>

                <div className="usage-section">
                  {selectedAuto.details.map((section, index) => (
                    <div className="usage-block" key={index}>
                      <h3>{section.title}</h3>

                      <ul>
                        {section.points.map((point, i) => (
                          <li key={i}>{point}</li>
                        ))}
                      </ul>
                    </div>
                  ))}
                </div>

                <button className="close-btn" onClick={closeModal}>
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </>
  );
}